import { useCallback, useEffect, useState } from 'react';
import './styles.css';

import { Button } from 'primereact/button';
import 'react-tabs/style/react-tabs.css';
import { useHistory } from 'react-router-dom';

import Paper from '@material-ui/core/Paper';
import Tour from '../Tour';
import { stepsLixeira } from '../Tour/steps';
import { useTour } from '@reactour/tour';
import { InputIcon } from '../../components/ui/input';

import { TrashIcon, MagnifyingGlassIcon } from '@radix-ui/react-icons';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../components/ui/alert-dialog';

import api from '../../services/api';
import { format } from 'date-fns';

import { ToastAction } from '../../components/ui/toast';
import { useToast } from '../../components/ui/use-toast';

export default function AtasExcluidas(props) {
  const history = useHistory();
  const { setSteps } = useTour();

  const [atas, setAtas] = useState([]);
  const [atasFiltered, setAtasFiltered] = useState([]);
  const [setUser] = useState({});
  const { toast } = useToast();

  const perfilInfoHandler = useCallback(async () => {
    try {
      let token = localStorage.getItem('auth-token');
      const userRes = await api.get('/api/user/perfil', {
        headers: { 'x-auth-token': token },
      });
      const ataRes = await api.get('/api/ata/minhas/excluidas', {
        headers: { 'x-auth-token': token },
      });
      setUser(userRes.data);
      setAtas(ataRes.data);
      setAtasFiltered(ataRes.data);
    } catch (err) {
      console.log(err);
    }
  }, [setUser]);

  useEffect(() => {
    perfilInfoHandler();
    setSteps(stepsLixeira);
  }, [perfilInfoHandler, setSteps]);

  const [selectedAtas, setSelectedAtas] = useState([]);

  const handleCheckboxClick = (ataId) => {
    const updatedSelectedAtas = [...selectedAtas];

    if (updatedSelectedAtas.includes(ataId)) {
      const index = updatedSelectedAtas.indexOf(ataId);
      updatedSelectedAtas.splice(index, 1);
    } else {
      updatedSelectedAtas.push(ataId);
    }

    setSelectedAtas(updatedSelectedAtas);
  };

  const inicialNome = (owner) => {
    if (!owner) return '??';

    let listaNome = owner.split(' ');
    let tamanhoListaNome = listaNome.length;
    let sigla = listaNome[0][0] + listaNome[tamanhoListaNome - 1][0];

    return sigla;
  };

  async function handleDesfazerAcao() {
    try {
      console.log('Função handleDesfazerAcao chamada.');
      console.log('SelectedAtas:', selectedAtas);
      if (!selectedAtas || selectedAtas.length === 0) {
        console.warn('Nenhuma ata selecionada para restaurar.');
        return;
      }

      console.log('IDs das atas a serem restauradas:', selectedAtas);

      for (const ataId of selectedAtas) {
        let token = localStorage.getItem('auth-token');

        await api.put(`/api/atas/${ataId}`, {
          headers: { 'x-auth-token': token },
          body: { trash: true },
        });
      }
      setSelectedAtas([]);
      console.log(selectedAtas);
      setShouldRedirect(true);

      // Fecha a modal
      closeModal();
      perfilInfoHandler();
    } catch (error) {
      console.error('Erro ao restaurar atas:', error);
    }
  }

  const handleRestaurarSelecionados = async () => {
    try {
      if (!selectedAtas || selectedAtas.length === 0) {
        console.warn('Nenhuma ata selecionada para restaurar.');
        return;
      }

      toast({
        title: 'Documento recuperado',
        description:
          'O documento foi removido da lixeira e encontra-se na aba de documentos.',
        action: (
          <ToastAction altText="Desfazer" onClick={handleDesfazerAcao}>
            Desfazer
          </ToastAction>
        ),
      });

      for (const ataId of selectedAtas) {
        let token = localStorage.getItem('auth-token');

        await api.put(`/api/atas/restaurar/${ataId}`, {
          headers: { 'x-auth-token': token },
          body: { trash: false },
        });
      }
      setSelectedAtas([]);
      setShouldRedirect(true);

      // Fecha a modal
      closeModal();
      perfilInfoHandler();
    } catch (error) {
      console.error('Erro ao restaurar atas:', error);
    }
  };

  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (shouldRedirect) {
      history.push('/atas-excluidas');
    }
  }, [shouldRedirect, history]);

  const handleExcluirSelecionados = async () => {
    try {
      console.log('Função handleExcluirSelecionados chamada.');

      if (!selectedAtas || selectedAtas.length === 0) {
        console.warn('Nenhuma ata selecionada para exclusão.');
        return;
      }

      console.log('IDs das atas a serem excluídas:', selectedAtas);

      for (const ataId of selectedAtas) {
        let token = localStorage.getItem('auth-token');

        await api.delete(`/api/ata/minhas/${ataId}`, {
          headers: { 'x-auth-token': token },
        });
      }

      toast({
        title: 'Documento removido',
        description: 'Documento foi permanentemente removido',
      });

      setShouldRedirect(true);
      setSelectedAtas([]);
      // Fecha a modal
      closeModal();
      perfilInfoHandler();
    } catch (error) {
      console.error('Erro ao excluir atas:', error);
    }
  };

  const CustomPaper = () => {
    return (
      <div
        elevation={24}
        style={{
          display: 'flex',
          marginBottom: '30px',
          flexWrap: 'wrap',
          paddingRight: '110px',
          paddingLeft: '180px',
        }}
      >
        {atasFiltered
          .filter((ata) => ata.trash)
          .sort((a, b) => {
            if (projetoSelecionado === 'maisRecente') {
              return new Date(b.criadoEm) - new Date(a.criadoEm);
            } else if (projetoSelecionado === 'maisAntiga') {
              return new Date(a.criadoEm) - new Date(b.criadoEm);
            }
            if (a[projetoSelecionado] < b[projetoSelecionado]) return -1;
            if (a[projetoSelecionado] > b[projetoSelecionado]) return 1;
            return 0;
          })
          .map((ata) => (
            <div
              style={{
                cursor: 'pointer',
                marginBottom: '15px',
              }}
            >
              <Paper
                elevation={2}
                className="suasatas"
                style={{
                  color: '#3900DB',
                  height: '120px',
                  fontSize: '1rem',

                  fontWeight: 700,
                  width: '13rem',
                  minHeight: '103px',

                  letterSpacing: '0.00938em',
                  margin: '0px',
                  borderRadius: '8px',
                  background: '#FAFAFA',
                  boxSshadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                  marginLeft: '15px',
                  paddinTop: '40px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    marginLeft: '15px',
                    margintop: '10px',
                    overflowY: 'auto',
                    alignItems: 'center',
                    width: '190px',
                    height: '50px',
                  }}
                >
                  {ata.cliente}
                </div>

                <div
                  className="suasatas"
                  style={{
                    color: '#000',
                    height: '80pl',
                    fontSize: '18px',

                    fontWeight: 500,
                    lineHeight: '1.5',
                    letterSpacing: '0.00938em',
                    margin: '0px',
                    justifyContent: 'start',
                    marginLeft: '15px',
                  }}
                >
                  {ata.projeto}
                </div>
                <div
                  className="suasatas"
                  style={{
                    color: '#858585',
                    display: 'flex',
                    height: '80pl',
                    fontSize: '14px',

                    fontWeight: 400,
                    fontStyle: 'italic',
                    lineHeight: '1.5',
                    letterSpacing: '0.00938em',
                    margin: '0px',
                    marginLeft: '15px',
                  }}
                >
                  {' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <circle cx="18" cy="18" r="18" fill="#3E2388" />
                  </svg>
                  <div
                    style={{
                      marginLeft: '-21px',
                      color: 'white',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      marginTop: '2px',
                      maxHeight: '60px',
                    }}
                  >
                    {ata.owner?.nome ? inicialNome(ata.owner.nome) : '??'}
                  </div>
                  <div
                    elevation={24}
                    style={{
                      marginLeft: '20px',
                      width: '20%',
                      display: 'flex',

                      boxSshadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                    }}
                  >
                    {format(new Date(ata.criadoEm), 'dd/MM/yyyy')}
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      checked={selectedAtas.includes(ata._id)}
                      onChange={() => handleCheckboxClick(ata._id)}
                      style={{
                        display: 'flex',
                        marginLeft: '88px',
                        marginTop: '-60px',
                      }}
                    />
                  </div>
                </div>
              </Paper>
            </div>
          ))}
      </div>
    );
  };

  const MeuComponente = () => {
    return (
      <div
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          width: '77vw',

          overflow: 'auto',
          height: '45%',
          position: 'fixed',
          marginTop: '350px',
        }}
      >
        {' '}
        {[...Array(1)].map((_, index) => (
          <CustomPaper key={index} />
        ))}
      </div>
    );
  };

  const [projetoSelecionado, setProjetoSelecionado] = useState('');

  const [termoPesquisa, setTermoPesquisa] = useState('');

  const handleSelecao = (value) => {
    console.log('Opção selecionada: ', value);
    setProjetoSelecionado(value);
  };

  const [setNomeProjetos] = useState([]);

  const [setCliente] = useState([]);

  const [colaboradores, setColaboradores] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (state) => {
    if (isModalOpen === false && !selectedAtas.length) {
      console.warn('Nenhuma ata selecionada para exclusão.');
      return;
    }
    setIsModalOpen(state);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const buscarProjetos = async () => {
      try {
        const response = await api.get('/api/buscarProjetos');
        setNomeProjetos(response.data);
      } catch (error) {
        console.error('Erro ao buscar Projetos:', error);
      }
    };

    buscarProjetos();
  }, [setNomeProjetos]);

  useEffect(() => {
    const buscarClientes = async () => {
      try {
        const response = await api.get('/api/buscarClientes');
        setCliente(response.data);
      } catch (error) {
        console.error('Erro ao buscar clientes:', error);
      }
    };

    buscarClientes();
  }, [setCliente]);

  useEffect(() => {
    const buscarColaboradores = async () => {
      try {
        let token = localStorage.getItem('auth-token');
        const response = await api.get('/api/ata/listarTodosUsuarios', {
          headers: { 'x-auth-token': token },
        });

        setColaboradores(response.data);
        console.log(colaboradores);
      } catch (error) {
        console.error('Erro ao buscar Colaboradores:', error);
      }
    };

    buscarColaboradores();
  }, [colaboradores]);

  const handleTermoPesquisaChange = (event) => {
    setTermoPesquisa(event.target.value);
    setAtasFiltered(
      atas.filter(
        (ata) =>
          ata?.projeto
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          ata?.cliente.toLowerCase().includes(event.target.value.toLowerCase()),
      ),
    );
  };
  return (
    <div style={{ overflow: 'hidden' }}>
      <nav
        className="navigation"
        style={{
          marginLeft: '15%',
          marginTop: '100px',
        }}
      >
        <ul>
          <li>
            <a href="/perfil">Home</a>
          </li>
          <li>/</li>
          <li>
            <a href="/documentos-ata">Atas</a>
          </li>
          <li>/</li>
          <li>
            <p>Lixeira</p>
          </li>
        </ul>
      </nav>
      <div
        style={{
          width: '100vw',
          height: '35vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <p
          className="title-lixeira"
          style={{
            fontSize: '35px',
            fontStyle: 'normal',
            fontWeight: '700',
            color: '#00293B',
            marginTop: '-328px',
            position: 'fixed',
          }}
        >
          Lixeira
        </p>
        <div
          style={{
            width: '1000px',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '-285px',
            position: 'fixed',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1372"
            height="10"
            viewBox="0 0 1372 10"
            fill="none"
          >
            <g filter="url(#filter0_d_110_89)">
              <path
                d="M4 1L1368 1.00012"
                stroke="#006998"
                stroke-opacity="0.55"
                stroke-width="2"
                shape-rendering="crispEdges"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_110_89"
                x="0"
                y="0"
                width="1372"
                height="10"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0.15 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_110_89"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_110_89"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div
          style={{
            display: 'flex',
            paddingTop: '-75px',
            marginRight: '100px',
            borderRadius: '8px',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '-190px',
            marginLeft: '-270px',
            position: 'fixed',
          }}
        >
          <div
            style={{
              marginRight: '260px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                marginLeft: '400px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <Select onValueChange={handleSelecao}>
                <SelectTrigger className="w-[180px] ordenar-atas-lixeira">
                  <SelectValue placeholder="Ordenar por" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="projeto">
                      Ordem alfábetica de Projeto
                    </SelectItem>
                    <SelectItem value="cliente">
                      Ordem alfábetica de Cliente
                    </SelectItem>
                    <SelectItem value="maisRecente">
                      Data mais recente
                    </SelectItem>
                    <SelectItem value="maisAntiga">Data mais antiga</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
              <div style={{ width: '200px' }}>
                <InputIcon
                  className="p-1 h-[38px] input-pesquisa-lixeira"
                  value={termoPesquisa}
                  onChange={handleTermoPesquisaChange}
                  icon={<MagnifyingGlassIcon className="h-[18px] w-[16px]" />}
                />
              </div>

              <AlertDialog open={isModalOpen} onOpenChange={openModal}>
                <AlertDialogTrigger>
                  <Button
                    icon={<TrashIcon className="h-[18px] w-[16px]" />}
                    className="p-button-outlined p-button-primary delete-ata-button"
                    variant="outline"
                    style={{
                      color: 'red',
                      fontFamily: 'Satoshi',
                      fontWeight: 500,
                      height: '35px',
                      width: '209px',
                    }}
                    // onClick={openModal}
                  >
                    Excluir selecionados
                  </Button>
                </AlertDialogTrigger>

                <AlertDialogContent
                  style={{
                    width: '600px',
                    fontWeight: '600',
                    color: 'black',
                    overflowY: 'visible',
                    boxShadow: 'rgb(0 0 0) 0px 3px 3px 0px',
                  }}
                >
                  <AlertDialogHeader>
                    <div className="p-d-flex p-ai-center">
                      <AlertDialogTitle
                        style={{
                          color: '#EC0000',
                          fontSize: '32px',
                          marginTop: '-65px',
                          display: 'flex',
                          justifyContent: 'center',
                          paddingTop: '65px',
                          fontWeight: '400',
                        }}
                      >
                        Atenção
                      </AlertDialogTitle>
                    </div>
                  </AlertDialogHeader>
                  <AlertDialogDescription
                    style={{
                      color: 'black',
                      fontWeight: '400',
                      fontSize: '16px',
                      marginTop: '10px',
                      marginBottom: '-20px',
                    }}
                  >
                    Ao pressionar excluir os documentos selecionados serão{' '}
                    <b style={{ fontWeight: '700' }}>
                      deletados permanentemente
                    </b>
                    .<br></br>
                    <br></br>
                    Deseja excluir os documentos mesmo assim?
                  </AlertDialogDescription>
                  <AlertDialogFooter
                    style={{
                      marginTop: '40px',
                      marginLeft: '150px',
                      display: 'flex',
                      position: 'static',
                    }}
                  >
                    <AlertDialogCancel
                      className="p-button-outlined p-button-primary"
                      style={{
                        color: 'black',
                        display: 'flex',
                        justifyContent: 'center',
                        fontSize: '13px',
                        fontWeight: '300',
                        borderColor: '#000000b8',
                      }}
                      onClick={closeModal}
                    >
                      Cancelar
                    </AlertDialogCancel>
                    <AlertDialogAction
                      className="p-button-outlined p-button-primary"
                      style={{
                        color: 'white',
                        fontWeight: '300',
                        backgroundColor: 'red',
                        fontSize: '13px',
                        width: '173px',
                        marginRight: '10px',
                      }}
                      onClick={() => handleExcluirSelecionados()}
                    >
                      Excluir documentos
                    </AlertDialogAction>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>

              <Button
                className="p-button-outlined p-button-primary restaurar-ata-button"
                variant="outline"
                style={{
                  color: '#3900DB',
                  fontFamily: 'Satoshi',
                  fontWeight: 500,
                  height: '35px',
                  width: '209px',
                }}
                onClick={handleRestaurarSelecionados}
              >
                Restaurar selecionados
              </Button>
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}
        ></div>
        <MeuComponente />
      </div>
      <div style={{ display: 'flex', marginTop: '2rem' }}>
        <Tour></Tour>
      </div>
    </div>
  );
}
